import { Wrap } from "@chakra-ui/react";
import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import {
  MF_ACCESS,
  MFAccessCatalog,
  MFCatalogItem,
} from "state/members/access_v2/catalogs";
import CatalogItem from "./CatalogItem";
import "./styles.css";

const CatalogTiles = ({
  selected,
  search,
  id,
}: {
  selected: MFAccessCatalog;
  search: string;
  id: string;
}) => {
  const currentAccess = MF_ACCESS.useListCurrentAccess(id);
  const currentRequests = MF_ACCESS.useListActiveRequests(id);
  const filteredItems = useMemo(
    () =>
      selected.items
        ?.filter((i) => i.name?.toLowerCase()?.includes(search.toLowerCase()))
        .sort((a, b) =>
          a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1,
        ),
    [id, search],
  );
  const [searchParams] = useSearchParams();
  const itemId = useMemo(() => searchParams.get("item_id"), [searchParams]);

  const activeRequests = useCallback(
    (item: MFCatalogItem) => {
      const ids = item.catalogItemSelectableResources.map(
        (c) => c.selectableResource?.id,
      );
      return currentRequests.filter((cr) =>
        ids.includes(cr.selectableResourceId),
      );
    },
    [currentRequests],
  );

  const itemCurrentAccess = useCallback(
    (item: MFCatalogItem) => {
      const resourceIds = item.catalogItemSelectableResources.map(
        (c) => c.selectableResource?.resourceId,
      );
      return currentAccess.filter((ca) =>
        resourceIds.includes(ca.resourceId),
      );
    },
    [currentAccess],
  );
  return (
    <Wrap w="full" spacing={4} shouldWrapChildren>
      {filteredItems.map((item: MFCatalogItem, index: number) => (
        <CatalogItem
          item={item}
          key={item.id}
          catalogId={id}
          isOpen={itemId === item.id}
          activeRequests={activeRequests(item) || []}
          currentAccess={itemCurrentAccess(item)}
        />
      ))}
    </Wrap>
  );
};

export default CatalogTiles;
